"use strict";

var IpixModal = function() {};

IpixModal.initModal = () => {
    const closeButton = document.querySelector('[data-kt-modal-action="close"]');
    if (closeButton) {
        closeButton.addEventListener('click', e => {
            e.preventDefault();
            $(closeButton).parents(".modal").modal("hide");
        });
    }

    const cancelButton = document.querySelector('[data-kt-modal-action="cancel"]');
    if (cancelButton) {
        cancelButton.addEventListener('click', e => {
            e.preventDefault();
            $(closeButton).parents(".modal").modal("hide");
        });
    }
}

IpixModal.handleLoadRemoteHtml = function() {
    const loadButtons = document.querySelectorAll('[kt-load-remote-html="true"][kt-load-remote-init="false"]');
    if (loadButtons && $(loadButtons).length) {
        loadButtons.forEach(function(el) {
            el.setAttribute('kt-load-remote-init', 'true');
            el.addEventListener('click', function() {
                $.ajax({
                    method: "GET",
                    url: $(el).data('url'),
                    success: function(data) {
                        $("#model-area").html(data.html);
                        $.each(data.scripts, function(key, script) {
                            $.getScript(script);
                        });
                        IpixApp.createSelect2();
                        IpixForm.autoCompleteDisable();
                        IpixModal.initModal();
                        IpixMenu.createInstances();
                    },
                });
            });
        });
    }
}

IpixModal.init = function() {
    IpixModal.handleLoadRemoteHtml();
};

IpixUtil.onDOMContentLoaded(function() {
    IpixModal.init();
});

// Webpack support
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = IpixModal;
}